import { assign, setup } from 'xstate'

/**
 * Emergency machine context
 */
export interface EmergencyContext {
  /** Whether the emergency audio is currently playing */
  isAudioPlaying?: boolean
}

/**
 * Emergency machine events
 */
export type EmergencyEvent =
  | { type: 'AUDIO_STARTED' }
  | { type: 'AUDIO_STOPPED' }
  | { type: 'BACK' }

/**
 * Emergency state identifiers
 */
export type EmergencyStateId = 'emergency'

/**
 * Emergency XState machine
 *
 * This machine orchestrates the emergency alert flow:
 * 1. Display emergency alert with audio
 * 2. Provide controls for audio and navigation
 * 3. Return to start when done
 */
export const emergencyMachine = setup({
  types: {
    context: {} as EmergencyContext,
    events: {} as EmergencyEvent
  },
  actions: {
    markAudioStarted: assign({
      isAudioPlaying: () => true
    }),
    markAudioStopped: assign({
      isAudioPlaying: () => false
    }),
    resetContext: assign({
      isAudioPlaying: () => false
    })
  }
}).createMachine({
  id: 'emergency',
  initial: 'emergency',
  context: {
    isAudioPlaying: false
  },
  states: {
    emergency: {
      on: {
        AUDIO_STARTED: {
          actions: 'markAudioStarted'
        },
        AUDIO_STOPPED: {
          actions: 'markAudioStopped'
        },
        BACK: {
          actions: 'resetContext'
        }
      }
    }
  }
})
